import apiClient from "./client";
import {
  AuthResponse,
  RegisterData,
  LoginData,
  AuthProvidersResponse,
  AuthConfigResponse,
  EmailRegisterData,
  GoogleRegisterData,
  FaceRegisterData,
  EmailLoginData,
  GoogleLoginData,
  FaceLoginData,
} from "../types";

// Get available auth providers
export const getAuthProviders = async (): Promise<AuthProvidersResponse> => {
  const response = await apiClient.get<AuthProvidersResponse>(
    "/auth/providers"
  );
  return response.data;
};

// Get auth config (includes Google client ID)
export const getAuthConfig = async (): Promise<AuthConfigResponse> => {
  const response = await apiClient.get<AuthConfigResponse>("/auth/me");
  return response.data;
};

// Unified register function
export const register = async (data: RegisterData): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>("/auth/register", data);
  return response.data;
};

// Unified login function
export const login = async (data: LoginData): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>("/auth/login", data);
  return response.data;
};

// Helper functions for specific auth types
export const registerWithEmail = async (
  email: string,
  password: string,
  firstName: string,
  lastName?: string
): Promise<AuthResponse> => {
  const data: EmailRegisterData = {
    auth_provider: "email",
    email,
    password,
    first_name: firstName,
    last_name: lastName,
  };
  return register(data);
};

export const registerWithGoogle = async (
  googleToken: string,
  email: string,
  firstName: string,
  lastName?: string
): Promise<AuthResponse> => {
  const data: GoogleRegisterData = {
    auth_provider: "google",
    google_token: googleToken,
    email,
    first_name: firstName,
    last_name: lastName,
  };
  return register(data);
};

export const registerWithFace = async (
  email: string,
  faceImage: string,
  firstName: string,
  lastName?: string
): Promise<AuthResponse> => {
  const data: FaceRegisterData = {
    auth_provider: "face",
    email,
    face_image: faceImage,
    first_name: firstName,
    last_name: lastName,
  };
  return register(data);
};

export const loginWithEmail = async (
  email: string,
  password: string
): Promise<AuthResponse> => {
  const data: EmailLoginData = {
    auth_provider: "email",
    email,
    password,
  };
  return login(data);
};

export const loginWithGoogle = async (
  googleToken: string
): Promise<AuthResponse> => {
  const data: GoogleLoginData = {
    auth_provider: "google",
    google_token: googleToken,
  };
  return login(data);
};

export const loginWithFace = async (
  faceImage: string
): Promise<AuthResponse> => {
  const data: FaceLoginData = {
    auth_provider: "face",
    face_image: faceImage,
  };
  return login(data);
};
